/**
 * Hero — Home page hero with team name, copy, CTA, and carousel.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import FeaturedCarousel from './FeaturedCarousel';
import styles from './Hero.module.css';

function Hero() {
  return (
    <section className={styles.hero}>
      <div className={styles.copy}>
        <p className="roar-eyebrow">FIRST Tech Challenge · Fairfax, VA</p>
        <h1 className={styles.title}>Fairfax Roarbotics</h1>
        <p className={styles.subline}>
          We design, build, and compete — one robot per season, from sketch to match day.
        </p>
        <Link to="/robot" className="roar-btn roar-btn-primary">
          See our robot
        </Link>
      </div>
      <div className={styles.media}>
        <FeaturedCarousel />
      </div>
    </section>
  );
}

export default Hero;
